module.exports = __webpack_public_path__ + "img/icon-warning-thunder-red.a6169e2c.svg";